import React from 'react';
import Stack from '@mui/material/Stack';
import Container from 'components/Layout/Container';
import { Link as RouterLink } from 'react-router-dom';
import SendIcon from '@mui/icons-material/ArrowForward';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import VideoPreview from 'components/CardConfigurer/steps/stepComponents/VideoPreview';
import useVideoAutoPlayback from 'effects/useVideoAutoPlayback';
import Box from '@mui/material/Box';
import { shopifyCDNFile } from 'lib/shopifyImageSizer';

const useStyles = makeStyles(
  (theme: Theme) => ({
    root: {
      padding: '80px 20px',
      textAlign: 'center',
      [theme.breakpoints.down('lg')]: {
        padding: '40px 10px',
      },
    },
    title: {
      lineHeight: 1.3,
    },
    subtitle: {
      margin: theme.spacing(3, 0),
    },
    description: {
      margin: '0 auto 5%',
      textAlign: 'center',
      [theme.breakpoints.up('md')]: {
        margin: '20% auto 20%',
      },
    },
    content: {
      margin: '0 auto',
      padding: '0 20px',
      maxWidth: '550px',
    },
    button: {
      marginTop: theme.spacing(6),
    },
    videoContainerStyle: {
      borderRadius: 40,
      overflow: 'hidden',
      position: 'relative',
      [theme.breakpoints.up('md')]: {
        height: 800,
      },
      [theme.breakpoints.down('md')]: {
        height: 500,
      },
    },
    videoStyle: {
      height: '100%',
      borderRadius: '40px',
    },
  }),
  { name: 'VideoMessageSection' },
);

const VideoMessageSection: React.FC<{ buttonTitle?: string; buttonLink?: string; title?: string; description?: string }> = ({ buttonTitle = '', buttonLink = '', title = '', description = '' }) => {
  const classes = useStyles();

  const [containerRef, videoRef] = useVideoAutoPlayback({
    root: null,
    rootMargin: '0px',
    threshold: 0.1,
  });

  const message = (
    <>
      {description && (
        <Typography component="div" variant="body1" className={classes.subtitle}>
          {description}
        </Typography>
      )}
      {buttonTitle && buttonLink && (
        <div className={classes.button}>
          <Button component={RouterLink} to={buttonLink} size="large" color="secondary" variant="outlined" endIcon={<SendIcon />}>
            {buttonTitle}
          </Button>
        </div>
      )}
    </>
  );
  return (
    <Container sx={{ flexGrow: 1 }} className={classes.root}>
      <Stack direction={{ xs: 'column', md: 'row' }} spacing={{ xs: 1, md: 2 }} marginTop={{ xs: 5, md: 10 }} marginBottom={{ xs: 7, md: 10 }} ref={containerRef}>
        <Box mb={[4, 0]} flexGrow={1}>
          <Stack spacing={1} className={classes.description} alignItems="center">
            <div className={classes.content}>
              {title && (
                <Typography variant="h1" className={classes.title}>
                  {title}
                </Typography>
              )}
              {message}
            </div>
          </Stack>
        </Box>
        <VideoPreview
          ref={videoRef}
          attributes={{
            // autoPlay: false,
            muted: 'muted',
            loop: true,
          }}
          videoURL={shopifyCDNFile('home-cardGiftThankYouMessage.mp4')}
          videoContainerStyle={classes.videoContainerStyle}
          videoStyle={classes.videoStyle}
          isVideoStoppable={false}
        />
      </Stack>
    </Container>
  );
};

export default VideoMessageSection;
